module.exports = __webpack_public_path__ + "img/email.c4ed210c.svg";